import { useEffect } from 'react';
import type { SitePhoto } from './demo2Data';

/* 현장사진 확대보기 공통 컴포넌트 — 작업 이력(단일 사진)과 수목 지도(구역별 여러 장)에서
 * 동일하게 사용한다. photos 배열이 1장이면 이전/다음 버튼은 자동으로 숨는다. */
interface Props {
    photos: SitePhoto[];
    index: number;
    onClose: () => void;
    onIndexChange: (i: number) => void;
}

export default function Demo2PhotoLightbox({ photos, index, onClose, onIndexChange }: Props) {
    const photo = photos[index];
    const hasMulti = photos.length > 1;
    const prev = () => onIndexChange((index - 1 + photos.length) % photos.length);
    const next = () => onIndexChange((index + 1) % photos.length);

    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
            if (hasMulti && e.key === 'ArrowLeft') prev();
            if (hasMulti && e.key === 'ArrowRight') next();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [index, photos.length]);

    if (!photo) return null;

    return (
        <div className="sian photo-lightbox-overlay" onClick={onClose}>
            <button className="photo-lightbox-close" onClick={onClose} aria-label="닫기"><i className="ri-close-line" /></button>
            {hasMulti && (
                <button className="photo-lightbox-nav prev" onClick={e => { e.stopPropagation(); prev(); }} aria-label="이전 사진">
                    <i className="ri-arrow-left-s-line" />
                </button>
            )}
            <div className="photo-lightbox-body" onClick={e => e.stopPropagation()}>
                <img src={photo.src} alt={photo.caption} />
                <div className="photo-lightbox-cap">
                    <span>{photo.caption}</span>
                    {hasMulti && <span className="photo-lightbox-cnt">{index + 1} / {photos.length}</span>}
                </div>
            </div>
            {hasMulti && (
                <button className="photo-lightbox-nav next" onClick={e => { e.stopPropagation(); next(); }} aria-label="다음 사진">
                    <i className="ri-arrow-right-s-line" />
                </button>
            )}
        </div>
    );
}
